import { useChatInstancesStore } from '../store/chatInstancesStore';

export type ChatSendDeliveryObserver = {
  stop: () => void;
  wasAcceptedByServer: () => boolean;
};

export const observeChatSendDelivery = ({
  chatId,
  subscribeToLiveStatus,
}: {
  chatId: string;
  subscribeToLiveStatus?: (onStatus: (status: string) => void) => () => void;
}): ChatSendDeliveryObserver => {
  let acceptedByServer = false;

  const markAccepted = (status: string | undefined) => {
    if (status === 'streaming') {
      acceptedByServer = true;
    }
  };

  const unsubscribeStore = useChatInstancesStore.subscribe((state) => {
    markAccepted(state.chatStatuses.get(chatId));
  });
  const unsubscribeLive = subscribeToLiveStatus?.(markAccepted);

  return {
    stop: () => {
      unsubscribeStore();
      unsubscribeLive?.();
    },
    wasAcceptedByServer: () => acceptedByServer,
  };
};
